/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserEventType {
    UserRegistered = 'UserRegistered',
    UserMigrated = 'UserMigrated',
    UserIdPortenValidated = 'UserIdPortenValidated',
    UserAccessRequested = 'UserAccessRequested',
    UserAccessRemoved = 'UserAccessRemoved',
    UserCancellationRequested = 'UserCancellationRequested',
    UserAccessLegalTermsAccepted = 'UserAccessLegalTermsAccepted',
    UserAcceptedGdpr = 'UserAcceptedGdpr',
    UserAccessApproved = 'UserAccessApproved',
    UserAccessAssigned = 'UserAccessAssigned',
    UserChangedEmployer = 'UserChangedEmployer',
    UserPhoneDeleted = 'UserPhoneDeleted',
    UserChangedName = 'UserChangedName',
    UserChangedEmail = 'UserChangedEmail',
    UserAcceptedGdprViaContract = 'UserAcceptedGdprViaContract',
    UserChangeMfaPhone = 'UserChangeMfaPhone'
}


export function instanceOfUserEventType(value: any): boolean {
    for (const key in UserEventType) {
        if (Object.prototype.hasOwnProperty.call(UserEventType, key)) {
            if (UserEventType[key as keyof typeof UserEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserEventTypeFromJSON(json: any): UserEventType {
    return UserEventTypeFromJSONTyped(json, false);
}

export function UserEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventType {
    return json as UserEventType;
}

export function UserEventTypeToJSON(value?: UserEventType | null): any {
    return value as any;
}

export function UserEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UserEventType {
    return value as UserEventType;
}

